export default "__VITE_ASSET__Cm_HxVuz__"